import { isFinite } from 'lodash';

import { Nil } from './type-utils';

// 1/4 (one quarter):
// Character: ¼  \u00BC
const QUARTER = '\u00BC';
//1/2 (one half):
//Character: ½  \u00BD
const HALF = '\u00BD';
//3/4 (three quarters):
//Character: ¾  \u00BE
const THREE_QUARTERS = '\u00BE';

export function roundNumberTo(val: number, places?: number | Nil): number;
export function roundNumberTo(val: Nil, places?: number | null | undefined): Nil;
export function roundNumberTo(val: number | Nil, places?: number | null | undefined): number | Nil;
export function roundNumberTo(val: number | Nil, places?: number | Nil): number | Nil {
    if (!Number.isFinite(val as number)) {
        return val;
    }

    if (!Number.isFinite(places as number) || (Number.isFinite(places as number) && (places as number) < 0)) {
        return val as number;
    }

    const multiplier = Math.pow(10, places as number);
    return Math.round((val as number) * multiplier) / multiplier;
}

export type QuarterFraction = 0 | 1 | 2 | 3;
type Fraction = Exclude<QuarterFraction, 0>;

export const FRACTION_MAP: Record<Fraction, string> = {
    1: QUARTER,
    2: HALF,
    3: THREE_QUARTERS,
};

export type FormattedInches = {
    isNegative: boolean;
    integer: number | null;
    quarterFraction: QuarterFraction | null;
};

export function formatInches(value: number): FormattedInches {
    if (!Number.isFinite(value)) {
        return { isNegative: false, integer: null, quarterFraction: null };
    }

    const absValue = Math.abs(value);
    const roundedInches = Math.round(absValue * 4) / 4;
    const wholeInches = Math.floor(roundedInches);

    const quarterFraction = Math.round((roundedInches - wholeInches) * 4) as QuarterFraction;
    return {
        isNegative: value < 0 && roundedInches > 0,
        integer: wholeInches === 0 && quarterFraction > 0 ? null : wholeInches,
        quarterFraction,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFiniteNumber: (val: any) => val is number = isFinite as any;
